


import React, { useState } from "react";
import LogisticsCancelandrefundpage from "../Logistics/LogisticsCancelandrefundpage";
import Logisticssettlementpage from "../Logistics/Logisticssettlementpage";

const LogisticsAccounts = () => {

    // ✅ TAB STATE
    const [activeTab, setActiveTab] = useState("Create Screens");

    // ✅ SCREEN STATES (from second code)
    const [showScreenModal, setShowScreenModal] = useState(false);
    const [screens, setScreens] = useState([]);

    const handleSaveScreens = (updatedScreens) => {
        console.log("Screens saved:", updatedScreens);
        setScreens(updatedScreens);
    };

    // ✅ RENDER LOGIC (UPDATED)
    const renderComponent = () => {
        switch (activeTab) {

            case "Cancel/Refund":
                return (
                    <LogisticsCancelandrefundpage />
                );

            case "Settelment":
                return <Logisticssettlementpage />;

            default:
                return (
                    <LogisticsCancelandrefundpage />
                );
        }
    };

    // ✅ TABS
    const tabs = [

        "Cancel/Refund",
        "Settelment",

    ];

    return (
        <div className="tabs-wrapper">

            {/* ✅ TOP TABS */}
            <div className="tabs-row">
                {tabs.map((tab) => (
                    <span
                        key={tab}
                        className={`row-tab ${activeTab === tab ? "active" : ""}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </span>
                ))}
            </div>

            {/* ✅ SCROLLABLE CONTENT */}
            <div
                className="tabs-content"
                style={{
                    overflowY: "auto",
                    scrollbarWidth: "none",
                    height: "calc(85vh - 120px)",
                    marginTop: "20px"
                }}
            >
                {renderComponent()}
            </div>

        </div>
    );
};

export default LogisticsAccounts;